import { isFreeFlow } from '@forwardflow/features/campaign-v2/utils/demo-mode'
import { ICampaignV2Api } from './campaign-v2.api'
import { demoCampaignV2Api } from './campaign-v2.demo'
import { liveCampaignV2Api } from './campaign-v2.live'

/**
 * The editor talks to one adapter. Free flow (`?dev=1`) and the no-sign-in
 * sandbox get the in-memory one, so nothing real is created while testing.
 */
export const campaignV2Api = (): ICampaignV2Api =>
   isFreeFlow() ? demoCampaignV2Api : liveCampaignV2Api

export type { ICampaignV2Api } from './campaign-v2.api'
export { resetDemoCampaigns } from './campaign-v2.demo'
